import { Module, MutationTree } from "vuex";

export class ChannelState {
  public channelId?: string;
}

const mutations: MutationTree<ChannelState> = {
  setChannelId(state: ChannelState, channelId: string): void {
    const isWeb = channelId.indexOf('_web');
    const isApp = channelId.indexOf('_app');
    if(isWeb != -1) channelId = channelId.slice(0, isWeb);
    if(isApp != -1) channelId = channelId.slice(0, isApp);
    state.channelId = channelId;
  },
};

export const ChannelStore: Module<ChannelState, any> = {
  namespaced: true,
  state: new ChannelState(),
  mutations,
};